module.exports = __webpack_public_path__ + "static/media/oschina.a88702cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/oschina.png
// module id = 164
// module chunks = 0